// BUSCAR SIN QUE IMPORTEN LAS TILDES (Francisco, 23-09: «el buscador de clientes distingue
// tildes, que no lo haga»). «jose» encuentra a «José», «rocio» a «Rocío» y «nunez» a
// «Núñez», y al revés. Se pasan los dos lados por aquí: lo que se escribe y lo que se busca.

//: El texto en minúsculas y sin tildes ni diéresis (la ñ pasa a n).
export const sinTildes = (s) => String(s ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

//: ¿Contiene `texto` lo buscado, sin mirar tildes ni mayúsculas? Vacío = todo vale.
export const contiene = (texto, buscado) => {
    const b = sinTildes(buscado).trim();
    return !b || sinTildes(texto).includes(b);
};
